import { Pressable, Text, View } from "react-native"
import { BulletinPaie } from "./FicheSalaire.types"
import styles from "./FicheSalaire.styles"
import { getMonthNumber } from "./FicheSalaire.component"
import { TooltipWrapper } from "@components"
import MaterialCommunityIcons from "react-native-vector-icons/MaterialCommunityIcons"
import dayjs from 'dayjs'
import { stdCouleurBleu } from "@commonStyle"

type BulletinItemProps = {
  item: BulletinPaie,
  onPress: (bulletin: BulletinPaie) => void
}

export default function BulletinItem({ item, onPress }: BulletinItemProps){
  return(
    <View style={styles.bulletinContainer}>
      <View style={styles.bulletinContent}>
        <View style={styles.bulletinInfo}>
          <View style={styles.bulletinTitle}>
            <Text style={styles.bulletinPeriode}>{getMonthNumber(item.mois)} {item.annee}</Text>
                                
            {item.dateCoffre && (
              <TooltipWrapper 
                tooltip={`Déposé sur le coffre-fort le ${dayjs(item.dateCoffre)?.format('DD/MM/YYYY')}`}
                style={styles.tooltipContainer}
                tooltipStyle={styles.tooltip}
              >
                <MaterialCommunityIcons 
                    name="safe" 
                    size={24} 
                    color={stdCouleurBleu}
                    accessibilityLabel={`Déposé sur le coffre-fort le ${dayjs(item.dateCoffre)?.format('DD/MM/YYYY')}`}
                  />
              </TooltipWrapper>
            )}   
          </View>
                      
          {item.periode && <Text style={styles.bulletinAnnee}>{item.periode}</Text>}
          
                {item.montantNet && item.statut === 'disponible' && (
            <Text style={styles.bulletinMontant}>
              {item.montantNet.toLocaleString('fr-FR', { 
                style: 'currency', 
                currency: 'EUR' 
              })}
            </Text>
          )}

          {item.statut !== 'disponible' && (
            <Text style={styles.bulletinStatut}>
              {item.statut === 'traitement' ? 'En traitement' : 'Non disponible'}
            </Text>
          )}
        </View>
        
        <Pressable 
          style={[
            styles.bulletinPdfButton,
            item.statut !== 'disponible' && styles.bulletinPdfButtonDisabled
          ]}
          onPress={() => item.statut === 'disponible' && onPress(item)}
          disabled={item.statut !== 'disponible'}
          testID={`BT_BULLETIN_${item.mois}_${item.annee}`}
        >
          <MaterialCommunityIcons 
            name="file-pdf-box" 
            size={32} 
            color={item.statut === 'disponible' ? '#dc2626' : '#9ca3af'} 
          />
        </Pressable>
      </View>
    </View>
  )
}